import { SessionService } from 'src/app/session-service.service';
import { Component, ViewEncapsulation, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: 'checkbox-input.html',
  styleUrls: ['checkbox-input.css'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxInputComponent extends BaseComponent implements OnInit {
  controlType = this.constructor.name;
  isDisabled: boolean;
  @Output()
  isChecked = new EventEmitter<boolean>();
  @Input()
  isWeightNormalLabel = false;

  constructor(translateService: TranslateService, sessionService: SessionService) {
    super(translateService, sessionService);
  }
  OnChange($event): void {
    this.isDisabled = !$event.checked;
    this.isChecked.emit(this.isDisabled);
  }
}
